'use client';

import React from 'react';
import MyPhotosWidget from 'components/commercetools-ui/organisms/my-photos-widget';
import { MyPhotosWidgetProps } from 'components/commercetools-ui/organisms/my-photos-widget/types';
import { TasticProps } from '../types';

const MyPhotosWidgetTastic = ({ data }: TasticProps<MyPhotosWidgetProps>) => {
  return <MyPhotosWidget {...data} />;
};

export default MyPhotosWidgetTastic;
